import { alpha, createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  interface Palette {
    lightPrimary: Palette['primary'];
    darkGrey: Palette['primary'];
    lightGrey: Palette['primary'];
  }

  interface PaletteOptions {
    lightPrimary?: PaletteOptions['primary'];
    darkGrey?: PaletteOptions['primary'];
    lightGrey?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    lightPrimary: true;
    darkGrey: true;
    lightGrey: true
  }
}

const appTheme = createTheme({
  typography: {
    fontFamily: 'KoHo, sans-serif',
    allVariants: {
      textTransform: 'none',
    },
  },
  palette: {
    primary: {
      main: '#43BDCE',
      contrastText: '#FFF',
    },
    secondary: {
      main: '#E85D3C',
      contrastText: '#FFF',
    },
    lightPrimary: {
      main: '#EDF9FB',
      contrastText: '#43BDCE',
    },
    darkGrey: {
      main: '#404040',
      light: alpha('#404040', 0.5),
      dark: alpha('#404040', 0.9),
      contrastText: '#FFF',
    },
    lightGrey: {
      main: '#F5F5F5',
      contrastText: '#404040',
    },
  },
  components: {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          minHeight: '40px',
          fontWeight: 700,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 4,
          fontWeight: 700,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFF',
          borderRadius: 8,
        },
      },
    },
  },
});

export default appTheme;
